const normalizeDigits = (value) => String(value || "").replace(/\D/g, "");

export const normalizeCountryPhoneCode = (countryCode) => normalizeDigits(countryCode);

export const toE164Phone = (phoneValue, countryCode = "1") => {
  const normalizedCountryCode = normalizeCountryPhoneCode(countryCode);
  if (!normalizedCountryCode) return "";

  const trimmed = String(phoneValue || "").trim();
  if (!trimmed) return "";

  const digits = normalizeDigits(trimmed);
  if (!digits) return "";

  if (trimmed.startsWith("+")) {
    return `+${digits}`;
  }

  if (digits.startsWith(normalizedCountryCode) && digits.length > normalizedCountryCode.length) {
    return `+${digits}`;
  }

  return `+${normalizedCountryCode}${digits}`;
};

export const toNationalPhone = (phoneValue, countryCode = "1") => {
  const normalizedCountryCode = normalizeCountryPhoneCode(countryCode);
  const digits = normalizeDigits(phoneValue);
  if (!digits) return "";

  if (normalizedCountryCode && digits.startsWith(normalizedCountryCode) && digits.length > normalizedCountryCode.length) {
    return digits.slice(normalizedCountryCode.length);
  }

  return digits;
};
